	import { ReactNode, createRef, useEffect, useRef, useState } from 'react';

import PageHead from '@/components/PageHead';
import PageLayout from '@/components/layout/page-layout';
import Container from '@/components/Container';
import HeadingOne from '@/components/Heading/HeadingOne';
import { ExtendProps } from 'app';

import NextImage from 'next/image';
import NextLink from 'next/link';

import { MdPsychology } from 'react-icons/md';
import { AiOutlineProject } from 'react-icons/ai';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import HorizontalRow from '@/components/HorizontalRow';

export default function Page() {
	const [isOpenDetails, setIsOpenDetails] = useState(
		Array.from({ length: 8 }, (ref, k) => false)
	);

	return (
		<>
			<PageHead
				page={{
					title: 'Instituto Deixe Vivo | Apoio',
					keywords:
						'OSC, Instituto, Deixe Vivo, Doação de órgãos e tecidos, transplantes, terceiro setor, apoio a instituição, apoio financeiro, patrocínio, doar para instituto, doar para OSC',
					colorScheme: 'light dark',
					description: 'Contribua para que o Instituto Deixe Vivo continue despertando a cultura da doação de órgãos e tecidos na sociedade',
					robots: 'follow, index',
				}}
				og={{
					description: 'Contribua para que o Instituto Deixe Vivo continue despertando a cultura da doação de órgãos e tecidos na sociedade',
					site_name: 'Instituto Deixe Vivo | Apoio',
					title: 'Instituto Deixe Vivo | Apoio',
					type: 'website',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						fbAdmins: 'instituto.deixevivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
						type: 'image/jpg',
						width: '1200',
						height: '1200',
					},
				}}
				twitter={{
					card: 'summary',
					description: 'Contribua para que o Instituto Deixe Vivo continue despertando a cultura da doação de órgãos e tecidos na sociedade',
					site: 'Instituto Deixe Vivo | Deixe Vivo por aí: a doação de órgãos em todos os lugares',
					title:
						'Instituto Deixe Vivo | Deixe Vivo por aí: a doação de órgãos em todos os lugares',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
					},
				}}
			/>
			<PageLayout>
				<Container className="py-8">
					<HeadingOne horizontalRow>Apoio às atividades do Instituto</HeadingOne>

					<section className="mt-4">
						<p>
							Para mantermos nossas atividades, as ações, os projetos e a
							gestão ativa, contamos com a solidariedade das pessoas que doam
							recursos financeiros, assim como patrocínios e pequenas doações
							individuais.
						</p>
						<p>
							Acreditamos que toda doação tem seu valor, portanto, doe quanto e
							quando puder!
						</p>
					</section>

					<section>
						<div className="mt-16 flex flex-col items-center flex-wrap md:flex-row md:justify-center md:gap-x-20 lg:gap-x-32 xl:justify-between xl:gap-x-8">
							<DonorCard
								Icon={<RiMoneyDollarCircleLine className="text-3xl" />}
								value={'25,00'}
								description="Contribua para que o Instituto Deixe Vivo continue despertando a
              cultura da doação de órgãos e tecidos na sociedade"
								// externalLink={{ href: 'https://pag.ae/7Z2oZYENN' }}
								externalLink={{ href: 'https://doa.re/deixevivo' }}
							/>
							<DonorCard
								Icon={<RiMoneyDollarCircleLine className="text-3xl" />}
								value={'50,00'}
								description="Apoie o desenvolvimento e crescimento dos projetos do Instituto, para continuarmos levando informação, inspiração e acolhimento"
								// externalLink={{ href: 'https://pag.ae/7Z2p29h11',
								externalLink={{ href: 'https://doa.re/deixevivo' }}
							/>
							{/* <DonorCard
								Icon={<RiMoneyDollarCircleLine className="text-3xl" />}
								value={'75,00'}
								description="Ajude-nos a alcançar ainda mais pessoas com nossas ações e eventos para a sociedade"
								// externalLink={{ href: 'https://pag.ae/7Z2p3Cyzp',
								externalLink={{ href: 'https://doa.re/deixevivo' }}
							/> */}
							<DonorCard
								Icon={<RiMoneyDollarCircleLine className="text-3xl" />}
								value={'100,00'}
								description="Pense junto com a gente no futuro do Instituto, para que possamos crescer e levar voz e representatividade para a causa!"
								// externalLink={{ href: 'https://pag.ae/7Z2p5P4Qp',
								externalLink={{ href: 'https://doa.re/deixevivo' }}
							/>
							<DonorCard
								Icon={<RiMoneyDollarCircleLine className="text-3xl" />}
								value={'200,00'}
								description="Mais de 65 mil pessoas aguardam por um transplante, ajude-nos a conscientizar mais pessoas sobre a importância de se declarar um(a) doador(a) de órgãos e tecidos!"
								// externalLink={{ href: 'https://pag.ae/7Z2p9rYr4',
								externalLink={{ href: 'https://doa.re/deixevivo' }}
							/>
						</div>

						{/* <p className="mt-8">
							Para ser um apoiador mensal e contribuir mensalmente com as ações
							e projetos do Instituto, envie um e-mail para:{' '}
							<NextLink
								className="text-blue-600"
								href="mailto:financeiro@deixevivo.org.br"
							>
								financeiro@deixevivo.org.br
							</NextLink>
						</p> */}
					</section>

					{/* Imagem */}

					<HorizontalRow className="mt-8" />

					<div className="mt-8">
						<section>
							<h2 className="font-bold text-2xl text-center" tabIndex={0}>
								Motivos para doar
							</h2>
							<p className="my-4" tabIndex={0}>
								Separamos 8 motivos para você apoiar o Instituto Deixe Vivo.
								(clique ou toque nos items para saber os detalhes)
							</p>

							<ul>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Vamos Juntos
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											O Instituto nasceu da vontade e necessidade de despertar a
											cultura da doação de órgãos no Brasil. Com a sua doação
											você faz parte disso e contribui para que possamos atingir
											nossa missão e ter um país mais doador por meio das nossas
											ações!
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Informação
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											Através da informação clara, objetiva e de fácil
											compreensão o Instituto pretende transpor as barreiras que
											ainda cercam o tema da doação de órgãos e tecidos.
											Acreditamos que através de ações e eventos, podemos
											aprofundar melhor o assunto e esclarecer possíveis
											dúvidas.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Inspiração
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											O Instituto busca inspirar a sociedade em geral por meio
											de conteúdos, ações e eventos que debatem a importância da
											doação de órgãos. Acreditamos que dessa forma as pessoas
											terão a segurança necessária para se declararem doadoras
											de órgãos e tecidos.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Acolhimento
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											Nossos projetos levam acolhimento para pacientes
											transplantados e em lista de espera para proporcionar mais
											conforto e segurança para o tratamento. O atendimento
											acontece de forma totalmente online, abrangendo pessoas de
											todo o Brasil, quanto mais verba, mais pacientes
											conseguimos ajudar.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Representatividade
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											Para o Instituto é de extrema importância estar inserido
											nos espaços de decisão e assim motivar e auxiliar o grupo
											do qual faz parte, a conquistar e se apropriar daquilo que
											lhe pertence. Cada pessoa é única e merece oportunidade de
											trabalho, saúde e lazer, independente do diagnóstico
											crônico que carrega.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Contribuição
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											Fazendo sua doação, você contribuirá não só com os
											projetos e ações do #idv, mas também mudará a realidade de
											mais de 50 mil pessoas que aguardam por um órgão para
											transplante em lista de espera. A sua contribuição pode
											ser a oportunidade de vida para outra pessoa. Pense nisso.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Futuro
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											Queremos que o Instituto cresça para além do ambiente
											digital. Esse é um dos nossos planos futuros. Ter uma
											estrutura financeira pode garantir mais lugares onde as
											ações e campanhas podem chegar, até mesmo nas pequenas
											cidades do Brasil.
										</p>
									</details>
								</li>
								<li>
									<details className="[open:padding:5rem] py-2 border-b-2">
										<summary className='cursor-pointer [list-style-type:"❤"] text-primary-dark'>
											<strong className="ml-2 text-black font-bold">
												Educação
											</strong>
										</summary>
										<p tabIndex={0} className="py-4">
											O Instituto promove ações de educação em saúde com os
											temas de doação de órgãos, sangue e medula, propondo nas
											escolas, universidades e empresas, palestras online e
											presenciais. Com investimento conseguimos chegar em cada
											vez mais lugares e educar cada vez mais pessoas sobre o
											tema.
										</p>
									</details>
								</li>
							</ul>
						</section>
					</div>
				</Container>
			</PageLayout>
		</>
	);
}

type DonorProps = ExtendProps<{
	Icon: ReactNode;
	isBestOption?: boolean;
	value: string;
	description: string;
	externalLink?: {
		href: string;
	};
}>;

function DonorCard(props: DonorProps) {
	return (
		<div className="relative w-[224px] h-[320px] flex flex-col bg-white shadow-md rounded-lg mb-16">
			{/* Header */}
			<div className="relative w-full border-b-8 border-primary-light h-[3.5rem] bg-primary-dark">
				<div className="p-1 w-[48px] h-[48px] rounded-full left-[50%] translate-x-[-50%] absolute text-center top-[-24px] bg-primary-dark text-white border-b-4 border-b-primary-light flex items-center justify-center">
					{props.Icon}
				</div>

				{props.isBestOption && (
					<div className="bg-yellow-400 absolute right-[-24px] top-[-12px] rounded font-bold py-1 px-2 text-xs">
						Melhor opção!
					</div>
				)}
			</div>
			{/* Body */}
			<div className="relative flex flex-col items-center justify-evenly p-4 h-full">
				<div className="text-primary-dark font-bold text-2xl">
					R$ {props.value}
				</div>
				<div className="mt-2">
					<p className="text-center">{props.description}</p>
				</div>
			</div>
			{/* Footer */}
			<div className="relative w-full">
				<div className="absolute w-max mx-auto left-[50%] translate-x-[-50%] top-[-16px]">
					<NextLink
						href={props.externalLink.href}
						target="_blank"
						className="button p-2 px-6 rounded text-white font-bold"
					>
						<span>Apoiar</span>
					</NextLink>
				</div>
			</div>
		</div>
	);
}

type ReasonProps = ExtendProps<{}>;
function Reason(props: ReasonProps) {
	return <div></div>;
}
